import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg">
          <div className="bg-amber-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-amber-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-4" data-testid="cancel-title">
            Subscription Cancelled
          </h1>
          
          <p className="text-slate-600 mb-6">
            Your subscription process was cancelled. Don't worry - you haven't been charged and can try again whenever you're ready.
          </p>
          
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/subscription')}
              className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white gap-2"
              data-testid="try-again-button"
            >
              <RefreshCcw className="w-4 h-4" />
              Try Again
            </Button>
            
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="w-full gap-2"
              data-testid="back-to-dashboard-button"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Dashboard
            </Button>
          </div>
          
          <p className="text-sm text-slate-500 mt-6">
            Need help? Contact us at{' '}
            <a href="mailto:support@tabedlab.com" className="text-blue-600 hover:underline">
              support@tabedlab.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
